const columns = [
	{
		label: 'Program ID',
		msgKey: 'SWCC000366',
		prop: 'pgmId',
		fixed: true,
		width: 200
	},
	{
		label: '프로그램',
		msgKey: 'SWCC000371',
		prop: 'pgmName',
		fixed: true,
		width: 350
	},
	{
		label: 'Process ID',
		msgKey: 'SWCC000284',
		prop: 'procId',
		fixed: true,
		custom: true,
		width: 200
	},

	{
		label: 'Process Name',
		msgKey: 'SWCC000285',
		prop: 'procName',
		width: 300
	},
	{
		label: '순서',
		msgKey: 'SWCC000373',
		prop: 'exeSeq',
		width: 100
	},
	{
		label: 'Proc Run',
		msgKey: 'SWCC000374',
		prop: 'procExeStat',
		width: 200
	},
	{
		label: 'Proc Status',
		msgKey: 'SWCC000375',
		prop: 'procStat',
		width: 200
	},
	{
		label: 'Proc Control',
		msgKey: 'SWCC000376',
		prop: 'procControl',
		width: 200
	},
	{
		label: 'Resp Port',
		msgKey: 'SWCC000377',
		prop: 'respPort',
		width: 200
	},
	{
		label: 'Device Status',
		msgKey: 'SWCC000378',
		prop: 'devStat',
		width: 200
	},
	{
		label: 'Heart Bit Cycle',
		msgKey: 'SWCC000379',
		prop: 'procStatUpTime',
		width: 200
	},
	{
		label: 'Heart Bit DT',
		msgKey: 'SWCC000380',
		prop: 'heartDt',
		width: 200
	},
	{
		label: 'Server IP',
		msgKey: 'SWCC000381',
		prop: 'svrIp',
		width: 200
	},
	{
		label: 'Server Name',
		msgKey: 'SWCC000383',
		prop: 'svrName',
		width: 200
	},
	{
		label: 'Watch Flag',
		msgKey: 'SWCC000382',
		prop: 'stateMonFlg',
		width: 200
	}
];

export default columns;
